<template>
  <div class="full-size">
    <LongestStreak
      v-if="topAudiences && topAudiences.length && !loading"
      :topAudiences="topAudiences"
      :isFinalSlide="finalSlide"
    />

    <div class="full-size leaderboard-wrap">
      <div
        v-show="showWinner && showCarousel && !isBackstage && !loading"
        class="winner horizontal layout center center-justified animate__bounceIn animate__animated"
        :class="{'white': $store.state.slideActive.textColour == '#ffffff'}"
      >
        <div class="close-icon pointer small" @click="toggleCarousel">
          <i class="fas fa-times" />
        </div>

        <div v-if="!topWinnerStr && topAudiences && topAudiences[0]" class="winner-list-top">
          <div class="box-winer">
            <div class="winner-name">
              <span
                v-if="canFilterProfanity(topAudiences[0])"
              >{{ topAudiences[0].audienceName | profanity }}
              </span>
              <span v-else>
                {{ topAudiences[0].isCensorName ?
                  topAudiences[0].censorName : topAudiences[0].audienceName }}
              </span>
            </div>
            <div class="winner-emoji">
              {{ topAudiences[0].audienceEmoji }}
            </div>
          </div>
          <div class="winner-point">
            {{ topAudiences[0].totalPoint | formatTotalPoint }}
            <span
              class="short-cut-text"
            >{{ $t("points") }}</span>
          </div>
        </div>
        <div v-show="topWinnerStr" class="winner-list-top">
          <div class="text-center winner-title" v-html="$t('weHaveWinners', {msg: countWinner})" />
          <div class="marquee">
            <div class="marquee--text" :style="{'animation': timeRunbanner}">
              {{ $t("congratulationsTo") }} {{ topWinnerStr | profanity }}!
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="leaderboard--content vertical layout">
        <div
          v-if="!noData"
          id="top-audience-quiz"
          ref="leaderboard-content"
          class="top-audience"
        >
          <div
            class="box-audience-list"
            :class="{'horizontal layout center': topAudiences.length < minNumberOfDisplayedPlayer}"
          >
            <transition-group
              name="leaderboard"
              tag="ul"
              class="box-audience-wrapper"
              style="padding-left: 0; width: 100%;"
            >
              <li
                v-for="(item,index) in listAudienceShow"
                :key="item.audience"
                class="audience--item horizontal layout center"
                :class="{'final-animation': index == 0 && finalSlide}"
              >
                <div
                  class="audience--rank"
                  :class="{'visible': isAudienceRankVisible}"
                >
                  <span class="audience--rank-wrapper">
                    <span class="audience--rank-text font-weight-bold">{{ item.index }}</span>
                    <span
                      class="audience--rank-circle"
                      :class="{'white': $store.state.slideActive.textColour == '#ffffff'}"
                    />
                  </span>
                </div>
                <div
                  class="audience--bar"
                  :class="{'dark-theme': $store.state.slideActive.textColour == '#ffffff'}"
                >
                  <!-- Color bar layer 2-->
                  <div
                    class="audience--bar-progress layer--2"
                    :style="{'width': item.oldPercent + '%', 'background-color': getBarColor(item)}"
                    :class="{'animation': animation, 'has-leaderboard-swap': isNextLeaderboard}"
                  >
                    <div class="px-3 audience--bar-info layer--1">
                      <div class="bar--name">
                        <div class="player-name">
                          <span class="player-name__text">
                            <span class="pr-2 bar--emoji">
                              <span>{{ item.audienceEmoji }}</span>
                            </span>
                            <span v-if="canFilterProfanity(item)" class="font-weight-bold">
                              {{ item.audienceName | profanity }}
                            </span>
                            <span v-else class="font-weight-bold">
                              {{ item.isCensorName ? item.censorName : item.audienceName }}
                            </span>
                          </span>

                          <span v-if="canModifyLeaderboard" class="ml-3 action">
                            <span class="mr-2" @click="addManualPoints(item)">
                              <i
                                class="fas fa-arrow-alt-circle-up"
                              />
                              {{ $t('points') }}
                            </span>

                            <span @click="addCensorName(item)">
                              <i
                                class="fas"
                                :class="item.isCensorName ?
                                  'fa-eye' : 'fa-eye-slash'"
                              />
                              {{ $t('name') }}
                            </span>
                            <ButtonStartVoice
                              v-if="item.audience"
                              class="button-voice"
                              :audienceUnique="item.audience"
                              :audienceName="item.audienceName"
                            />
                          </span>
                        </div>
                        <div v-if="$store.state.presentation.teamPlay" class="team-name">
                          <span>{{ getTeamName(item) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Audience info layer 3 -->
                  <div class="px-3 audience--bar-info layer--3">
                    <div class="bar--name">
                      <div class="player-name">
                        <span class="player-name__text">
                          <span class="pr-2 bar--emoji">
                            <span>{{ item.audienceEmoji }}</span>
                          </span>
                          <span v-if="canFilterProfanity(item)" class="font-weight-bold">
                            {{ item.audienceName | profanity }}
                          </span>
                          <span v-else class="font-weight-bold">
                            {{ item.isCensorName ? item.censorName: item.audienceName }}
                          </span>
                        </span>

                        <span v-if="canModifyLeaderboard" class="ml-3 action">
                          <span class="mr-2" @click="addManualPoints(item)">
                            <i
                              class="fas fa-arrow-alt-circle-up"
                            />
                            {{ $t('points') }}
                          </span>

                          <span @click="addCensorName(item)">
                            <i
                              class="fas"
                              :class="item.isCensorName ?
                                'fa-eye' : 'fa-eye-slash'"
                            />
                            {{ $t('name') }}
                          </span>
                          <ButtonStartVoice
                            v-if="item.audience"
                            class="button-voice"
                            :audienceUnique="item.audience"
                            :audienceName="item.audienceName"
                          />
                        </span>
                      </div>
                      <div v-if="$store.state.presentation.teamPlay" class="team-name">
                        <span>{{ getTeamName(item) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="audience--points horizontal layout end">
                  <CountPointLeaderboard
                    :old-point="item.oldPoint"
                    :total-point="item.totalPoint"
                    :has-leaderboard-swap="isNextLeaderboard"
                  />
                  <NewPoint
                    :item="item"
                  />
                </div>
              </li>
            </transition-group>
          </div>
        </div>
        <div
          v-if="scrollShow && !noData"
          class="pt-1 arrow-grid animate__animated animate__flash animate__slow animate__delay-5s"
          :class="{'disabled': scrollDisable}"
        >
          <i class="fas fa-chevron-down arrow-down" @click="scrollBottom" />
        </div>

        <div v-if="noData" class="no-data horizontal layout center center-justified">
          <div>
            <strong class="quiz--result font-weight-bold">{{ $t("noResultYet") }}</strong>
            <p class="quiz--result-desc">
              {{ $t("theTopQuizPlayer") }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="loading" class="horizontal layout center center-justified full-size">
        <div class="text-center">
          <div class="quiz--result">
            {{ $t("loadingResult") }}...
          </div>
          <Loading style="margin: 0 auto" />
        </div>
      </div>
      <AddManualPointPopup
        v-if="addPointVisible"
        :data="addPointData"
        :audiences="listAudienceShow"
        @ok="addPointOk"
        @close="addPointClose"
      />
    </div>
  </div>
</template>
<script>
import confetti from 'canvas-confetti'
import * as Sentry from '@sentry/vue'
import { mapActions, mapState } from 'vuex'
import Config from '@/config'
import Constant from '@/constant'
import Loading from '@/components/Loading'
import Util from '@/util'
import EventBus from '@/eventBus'
import Socket from '@/socket'
import CountPointLeaderboard from '@/components/presentations/CountPointLeaderboard.vue'
import NewPoint from '@/components/presentations/NewPoint.vue'
import AddManualPointPopup from '@/components/AddManualPointPopup.vue'
import LeaderboardMixin from './LeaderboardMixin.vue'

import ButtonStartVoice from '@/components-v2/voice-audio/ButtonStartVoice.vue'
import LongestStreak from './LongestStreak.vue'

export default {
  components: {
    Loading,
    CountPointLeaderboard,
    AddManualPointPopup,
    NewPoint,
    ButtonStartVoice,
    LongestStreak,
  },
  mixins: [LeaderboardMixin],
  props: {
    showCarousel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      topAudiences: [],
      animation: false,
      noData: false,
      finalSlide: false,
      showWinner: false,
      topWinnerStr: '',
      countWinner: null,
      myReq: null,
      timeOut1: null,
      timeOut2: null,
      timeOut3: null,
      scrollShow: true,
      scrollDisable: false,
      listAudienceShow: [],
      blockAudiences: [],
      timeRunbanner: '',
      minNumberOfDisplayedPlayer: 10,
      teams: {},
      addPointData: {},
      addPointVisible: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    previousLeaderboard() {
      if (this.isFirstLeaderboard || !this.leaderboardIds) return null
      if (!this.$store.state.leaderboardSoloData) return null
      const currentIndex = this.leaderboardIds.indexOf(this.slideActive.id)
      const prevIndex = currentIndex - 1
      if (prevIndex === -1) return null
      return this.$store.state.leaderboardSoloData[this.leaderboardIds[prevIndex]]
    },
  },

  watch: {
    '$store.state.slideActive': function watchSlideActive() {
      this.checkShowScroll()
    },
    '$store.state.presentation.filteringProfanity': function oncChangeProfanityFilter() {
      if (!this.filteringProfanity) {
        localStorage.setItem('blockAudiences', JSON.stringify([]))
        this.blockAudiences = []
      }
      this.listAudienceShow.forEach((a) => {
        this.handleSetCensorNameOnProfanity(a)
      })
    },
  },
  mounted() {
    this.updateSlideActiveAction({
      audiencesCount: null,
    })
    this.$emit('showWinner', null)
    this.getData()
    const self = this
    EventBus.$on('sort-slide', () => {
      self.getData()
    })
    EventBus.$on('onKeyboard', (e) => {
      if (self.$store.state.slideActive.type == 'leaderboard') {
        self.handleSlideControlsKeydown(e)
      }
    })

    try {
      if (localStorage.getItem('blockAudiences')) {
        this.blockAudiences = JSON.parse(localStorage.getItem('blockAudiences'))
      }
    } catch (error) {
      this.blockAudiences = []
    }

    if (this.$store.state.sharePresentation) {
      Util.disallowPDFRender()
    }
  },
  destroyed() {
    EventBus.$off('sort-slide')

    if (this.myReq) {
      window.cancelAnimationFrame(this.myReq)
    }
    if (this.timeOut1) {
      window.clearTimeout(this.timeOut1)
      this.timeOut1 = null
    }
    if (this.timeOut2) {
      window.clearTimeout(this.timeOut2)
      this.timeOut2 = null
    }
    if (this.timeOut3) {
      window.clearTimeout(this.timeOut3)
      this.timeOut3 = null
    }

    document.body.classList.remove('hide-firework')
    Util.allowPDFRender()
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),
    addManualPoints(item) {
      const data = {
        ...item,
        name: `${item.audienceEmoji} ${item.audienceName}`,
        audienceId: item.audience,
        audienceTeam: null,
        slideId: this.$store.state.slideActive.id,
        presentationId: this.presentation.id,
        streak: item.streak,
        lastStreak: item.lastStreak,
        longestStreak: item.longestStreak,
        streakBonusPoint: item.streakBonusPoint || 0,
      }
      this.addPointData = data
      this.addPointVisible = true

      Util.mixpanelTracking(
        'Presentation Editor',
        'Leaderboard > Add manual point > Open popup',
        'Individual leaderboard',
      )
    },
    addPointOk() {
      this.getData(true)
    },
    addPointClose() {
      this.addPointVisible = false
    },
    canFilterProfanity(item) {
      return typeof (item.isCensorName) !== 'boolean'
    },
    setCensorName(item) {
      if (item.isCensorName) {
        item.censorName = Util.censorName(item.audienceName)
      }
      this.listAudienceShow.push()
    },
    handleSetCensorNameOnProfanity(audience) {
      let filter = this.presentation.filteringProfanity
      if (!filter) {
        filter = false
      }

      const indexAudienceBlock = this.blockAudiences.findIndex(
        (audienceData) => {
          return audienceData == audience.audience
        },
      )
      if (indexAudienceBlock !== -1) {
        audience.isCensorName = true
        audience.censorName = Util.censorNameLeaderBoard(audience.audienceName)
      } else {
        audience.isCensorName = filter
        if (audience.isCensorName) {
          this.setCensorNameOnProfanity(audience)
          if (!audience.censorName.includes('*')) {
            audience.isCensorName = false
          }
        }
      }
      // if (filter && audience.isCensorName) return
      Util.saveBlockAudience(audience)
    },
    setCensorNameOnProfanity(audience) {
      if (audience.isCensorName) {
        audience.censorName = Util.filterProfaneWordsWrapper(audience.audienceName)
      }
    },
    addCensorName(item) {
      item.isCensorName = !item.isCensorName

      if (item.isCensorName) {
        this.setCensorName(item)
        Util.mixpanelTracking('Presentation Editor', 'Leaderboard > Hide name')
      } else {
        Util.mixpanelTracking('Presentation Editor', 'Leaderboard > Show name')
      }
      Util.saveBlockAudience(item)
      this.blockAudiences = JSON.parse(localStorage.getItem('blockAudiences'))
    },
    checkInfinityScroll() {
      const listElm = document.querySelector('#top-audience-quiz')
      if (listElm) {
        listElm.addEventListener('scroll', () => {
          if (
            listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight - 50
          ) {
            if (this.listAudienceShow.length < this.topAudiences.length) {
              const from = this.listAudienceShow.length
              let to = from + 9
              if (this.topAudiences.length < to) {
                to = this.topAudiences.length
              }
              const arr = this.topAudiences.slice(from, to)
              this.listAudienceShow = this.listAudienceShow.concat(arr)
            }
          }
        })
      }
    },
    checkCurrentScore() {
      let check = false

      this.topAudiences.forEach((item) => {
        if (item.oldPoint != item.totalPoint) {
          check = true
        }
      })
      return check
    },
    getData(reload) {
      this.loading = true
      if (!this.$store.state.swapLeaderboard) {
        EventBus.$emit('leaderboard-loaded', false)
      }
      this.noData = false
      this.finalSlide = false
      this.showWinner = false
      this.$emit('showWinner', null)
      this.animation = false

      if (this.myReq) {
        window.cancelAnimationFrame(this.myReq)
      }

      const { slides } = this.presentation

      const slidesQuiz = slides.filter((item) => {
        return item.type == 'pickAnswer'
      })

      const index = Util.getIndexSlide(slides, this.$store.state.slideActive.id)
      let indexQuiz = 0
      if (slidesQuiz.length) {
        indexQuiz = Util.getIndexSlide(
          slides,
          slidesQuiz[slidesQuiz.length - 1].id,
        )
      }
      if (index > indexQuiz) {
        this.finalSlide = true
      }

      this.updateSlideActiveAction({
        timestampLeaderboard: new Date().getTime(),
      })

      // Config.api.getResultLeaderboard
      const slideId = this.$store.state.slideActive.id
      const presentationId = this.presentation.id || this.$route.params.id
      const payloadLeaderboard = {
        presentationId,
        slideId: this.$store.state.slideActive.id,
        finalSlide: this.finalSlide,
        accessCode: this.presentation.uniqueAccessCode,
        order: this.$store.state.slideActive.order,
        sharePresentation: this.$store.state.sharePresentation,
        timestampFile: this.$store.state.slideActive.timestampLeaderboard,
      }

      if (this.$store.state.isAdmin) {
        payloadLeaderboard.sharePresentation = true
      }

      this.$http
        .post(Config.api.createLeaderboard, payloadLeaderboard)
        .then(
          (res) => {
            if (slideId != this.$store.state.slideActive.id) {
              return
            }
            EventBus.$emit('leaderboard-loaded', true)

            let total = 0
            if (res.body.audiences.length) {
              total = res.body.audiences[0].totalPoint
            } else {
              this.noData = true
            }
            if (!res.body.totalAudiences) res.body.totalAudiences = 0

            this.updateSlideActiveAction({
              audiencesCount: Util.numberWithCommas(res.body.totalAudiences),
            })

            res.body.audiences.forEach((item, key) => {
              const lengthOfProgressBarInPercentage = (item.oldPoint / total) * 100

              if (lengthOfProgressBarInPercentage > 100) {
                item.oldPercent = 100
              } else if (lengthOfProgressBarInPercentage < 1 || !lengthOfProgressBarInPercentage) {
                item.oldPercent = 1
              } else {
                item.oldPercent = lengthOfProgressBarInPercentage
              }

              item.color = Constant.colors[key % 30]
              this.handleSetCensorNameOnProfanity(item)

              try {
                //
              } catch (error) {
                Sentry.captureException(error)
              }
            })

            this.topAudiences = res.body.audiences
            if (!this.$store.state.leaderboardSoloData) {
              this.$store.state.leaderboardSoloData = {}
            }
            this.$store.state.leaderboardSoloData[this.slideActive.id] = this.topAudiences
            this.topWinnerStr = res.body.topAudienceStr
            this.countWinner = res.body.countWinner

            if (res.body.lastName) {
              if (this.countWinner == 2) {
                this.topWinnerStr =
                  `${this.topWinnerStr
                  } ${
                    this.$t('and')
                  } ${
                    res.body.lastName}`
              } else if (this.countWinner > 2) {
                this.topWinnerStr =
                  `${this.topWinnerStr
                  }, ${
                    this.$t('and')
                  } ${
                    res.body.lastName}`
              }
            }

            if (this.topWinnerStr.length) {
              const timeRunBanner =
                25 + parseInt(this.topWinnerStr.length / this.minNumberOfDisplayedPlayer, 10)
              this.timeRunbanner = `marquee ${timeRunBanner}s linear infinite`
            } else {
              this.timeRunbanner = 'marquee 25s linear infinite'
            }
            this.topAudiences.push()
            this.loading = false
            this.animation = true
            const self = this
            let timeWait = 4000
            if (this.isNextLeaderboard) {
              timeWait = 4500
            }
            if (!this.checkCurrentScore()) {
              timeWait = 0
            }
            this.timeOut1 = setTimeout(() => {
              this.topAudiences.forEach((item, key) => {
                item.oldPercent = (item.totalPoint / total) * 100
                if (!item.oldPercent) {
                  item.oldPercent = 1
                }

                if (key >= this.minNumberOfDisplayedPlayer) {
                  item.oldPoint = item.totalPoint
                }
              })

              this.timeOut2 = setTimeout(() => {
                if (this.$store.state.sharePresentation) {
                  setTimeout(() => {
                    Util.allowPDFRender()
                  }, 2000)
                }
                if (
                  this.finalSlide &&
                  this.topAudiences.length &&
                  this.topAudiences[0].totalPoint
                ) {
                  this.showWinner = true
                  this.$emit('showWinner', this.$store.state.slideActive.id)
                  const canvas = document.getElementById('firework-canvas')
                  if (!canvas) return
                  canvas.confetti =
                    canvas.confetti ||
                    confetti.create(canvas, {
                      resize: true,
                    })
                  const colors = Constant.colorsHex.filter((item, key) => {
                    return item && key < this.minNumberOfDisplayedPlayer
                  })

                  const _startFirework = function () {
                    if (self.$store.state.isScreenCapture) return
                    let start = null
                    let count = 0
                    let timeFirework = 250
                    // eslint-disable-next-line
                    function step(timestamp) {
                      if (count == 3) {
                        timeFirework = 800
                      }
                      if (!start) start = timestamp
                      const progress = timestamp - start
                      if (progress > timeFirework) {
                        start = null
                        count++
                        canvas.confetti({
                          startVelocity: 5,
                          spread: 360,
                          ticks: 200,
                          decay: 0.98,
                          particleCount: 80,
                          shapes: ['circle'],
                          colors,
                          zIndex: 100,
                          origin: {
                            x: Math.random(),
                            // since they fall down, start a bit higher than random
                            y: Math.random() - 0.3,
                          },
                        })
                      }
                      self.myReq = window.requestAnimationFrame(step)
                    }
                    self.myReq = window.requestAnimationFrame(step)
                  }
                  this.timeOut3 = setTimeout(() => {
                    _startFirework(false)
                    this.timeOut3 = null
                  }, 500)
                }
                this.timeOut2 = null
              }, timeWait)
              this.timeOut1 = null
              this.checkShowScroll()
            }, 200)

            const arrAudiences = []
            for (let i = 0; i < this.topAudiences.length; i++) {
              if (i < this.minNumberOfDisplayedPlayer) {
                arrAudiences.push(this.topAudiences[i])
              } else {
                this.topAudiences[i].oldPoint = this.topAudiences[i].totalPoint
              }
            }

            arrAudiences.sort(this.audienceSorter)

            if (this.isFirstLeaderboard || !this.isNextLeaderboard || this.topAudiences.length > 200) {
              // show the leaderboard without animation from previous leaderboard (because we dont have prev leaderboard)
              // if there're >200 audience, do not animate
              this.listAudienceShow = arrAudiences
              this.isShowIndex = true
            } else {
              // show the leaderboard with animation, transition from prev leaderboard to the new leaderboard
              this.listAudienceShow = this.getLeaderboardToBeAnimated(this.topAudiences, this.previousLeaderboard)

              if (this.isLeaderboardRankChange(this.topAudiences, this.previousLeaderboard)) {
                setTimeout(() => {
                  this.listAudienceShow = arrAudiences
                  // show the index after rearranging the leaderboard
                  setTimeout(() => {
                    this.isShowIndex = true
                  }, 500)
                }, 2500)
              } else {
                this.isShowIndex = true
                this.listAudienceShow = arrAudiences
              }
            }
            this.$store.state.lastViewLeaderboardId = this.slideActive.id

            if (!this.$store.state.sharePresentation &&
              !this.$store.state.isAdmin &&
              !this.$store.state.isDisableEditPresentation &&
              this.$store.state.controllerSocketId === Socket.getSocketId()) {
              this.$http
                .put(
                  Config.api.updateNextSlide + presentationId,
                  {
                    activeSlide: this.$store.state.slideActive.id,
                    socketId: Socket.getSocketId(),
                    accessCode: this.presentation.uniqueAccessCode,
                    sharePresentation: this.$store.state.sharePresentation,
                    reload,
                  },
                )
                .then(
                  () => {
                  },
                  (err) => {
                    if (Sentry && err.status) {
                      Sentry.captureException(`Presenter put next slide leaderboard, status: ${err.status}`)
                    }
                  },
                )
            }

            setTimeout(() => {
              this.checkInfinityScroll()
            }, 1000)
          },
          () => {
            this.setSyncLoadingAction(3)
          },
        )

      this.checkSlideMovingDirectionAction(this.slideActive.id)

      if (index <= indexQuiz) {
        document.body.classList.add('hide-firework')
      }

      this.updateTeamData()
    },
    checkShowScroll() {
      setTimeout(() => {
        const container = this.$refs['leaderboard-content']
        this.scrollShow = container && container.scrollHeight > container.clientHeight
      })
    },
    handleSlideControlsKeydown(e) {
      if (this.$store.getters.isPresenting) {
        if (e.code == 'ArrowDown') {
          this.scrollBottom()
        } else if (e.code == 'ArrowUp') {
          this.scrollTop()
        }
      }
    },
    scrollBottom() {
      const container = this.$refs['leaderboard-content']

      if (!container) return

      Util.scrollToElement(container, {
        behavior: 'smooth',
        top: container.scrollTop + 400,
      })

      if (container.scrollTop + container.clientHeight === container.scrollHeight) {
        this.scrollDisable = true
      }
    },
    scrollTop() {
      const container = this.$refs['leaderboard-content']

      if (!container) return

      this.scrollDisable = false

      Util.scrollToElement(container, {
        behavior: 'smooth',
        top: container.scrollTop - 400 < 0 ? 0 : container.scrollTop - 400,
      })
    },

    toggleCarousel() {
      this.$emit('toggleShowCarousel', 'solo', this.$store.state.slideActive.id)
    },

    getBarColor(item) {
      return this.presentation.teamPlay
        ? (this.teams[item.audienceTeam] && this.teams[item.audienceTeam].color)
         || Util.getAhaColor(item.audienceTeam)
        : item.color
    },

    getTeamName(item) {
      return (this.teams[item.audienceTeam] && this.teams[item.audienceTeam].name) || this.$t('noTeam')
    },

    updateTeamData() {
      if (!this.presentation.teamData) {
        return
      }
      this.presentation.teamData.forEach((team) => {
        this.teams[team.id] = team
      })
    },

    getLeaderboardToBeAnimated(newLeaderboard, oldLeaderboard) {
      if (!newLeaderboard || !oldLeaderboard) return null
      const newLeaderboardMap = Util.fromArrayToMap(newLeaderboard, 'audience')
      oldLeaderboard.sort(this.audienceSorter)
      const audiencesRemoved = oldLeaderboard.filter((item) => {
        return newLeaderboard.map((i) => i.audience).includes(item.audience)
      }).map((item) => {
        return newLeaderboardMap[item.audience]
      })

      const audiencesAdded = newLeaderboard.filter((item) => {
        return !oldLeaderboard.map((i) => i.audience).includes(item.audience)
      })
      const animatingLeaderboard = audiencesRemoved.concat(audiencesAdded)

      return animatingLeaderboard.slice(0, this.minNumberOfDisplayedPlayer)
    },
    isLeaderboardRankChange(newLeaderboard, oldLeaderboard) {
      if (!newLeaderboard || !oldLeaderboard) return false
      const oldIds = oldLeaderboard.map((i) => i.audience).slice(0, this.minNumberOfDisplayedPlayer)
      const newIds = newLeaderboard.map((i) => i.audience).slice(0, this.minNumberOfDisplayedPlayer)
      return JSON.stringify(oldIds) !== JSON.stringify(newIds)
    },
    audienceSorter(a, b) {
      if (a.index < b.index) return -1
      if (a.index > b.index) return 1
      if (a.audienceName < b.audienceName) return 1
      if (a.audienceName > b.audienceName) return -1
      return 0
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
@import "@/assets/scss/animation.scss";

.leaderboard-wrap .audience--bar {
  height: auto;
}

.bar--name {
  width: 100%;
  margin: 10px 0;
}

.player-name {
  margin-top: 8px;
  line-height: 40px;
}

.team-name {
  font-size: 20px;
  font-weight: normal;
  line-height: 20px;
}

.arrow-grid {
  z-index: 4;
}

.arrow-down {
  position: relative;
  top: -11px;
}

.close-icon {
  position: absolute;
  top: 3px;
  right: 8px;
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
}

.player-name__text {
  max-width: 50%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: top;
}

.winner-emoji {
  font-weight: initial;
}

.button-voice {
  display: inline-block;
  position: relative;
  top: -3px;
  left: 3px;

  &::v-deep {
    .button-video-call {
      height: 38px;
      line-height: 37px;
      padding: 0 12px;
      margin-left: 2px;
    }
  }
}

</style>
